export const POI_ERROR = 'POI_ERROR';
export const POI_REQUEST = 'POI_REQUEST';
export const POI_SUCCESS = 'POI_SUCCESS';
